import { call, put, takeLatest } from '@redux-saga/core/effects';
import Apis from '../../../../api';
import { HEADERMENU_PATH } from '../../../../routes/RoutesURL';
import { CommonAction } from '../../../login/redux/types';
import { dealStatus, dealTypes } from '../../../login/utils/Status';
import MessageActions from '../../../message/redux/actions';
import commonUtils from '../utils';
import DealActions from './actions';
import DealTypes, { Deals } from './types';

const fetchDealsReq = function* fetchDealsReq() {
    try {
        const { data } = yield call(Apis.getDeals);
        const list = data || [];
        /**On going deals */
        const ongoingSorting = [dealStatus.active, dealStatus.upcoming, dealStatus.closed];
        const ongoingDeals =
            list &&
            list
                .filter(
                    (l: Deals) =>
                        (l && l.deal && l.deal.status === dealStatus.active) ||
                        (l && l.deal && l.deal.status === dealStatus.upcoming) ||
                        (l && l.deal && l.deal.status === dealStatus.closed),
                )
                .sort((a: Deals, b: Deals) => {
                    return (
                        ongoingSorting.indexOf(a && a.deal && a.deal.status) -
                        ongoingSorting.indexOf(b && b.deal && b.deal.status)
                    );
                });
        /**past deals */
        const pastSorting = [dealStatus.invested, dealStatus.completed];
        const pastDeals =
            list &&
            list
                .filter(
                    (l: Deals) =>
                        (l && l.deal && l.deal.status === dealStatus.invested) ||
                        (l && l.deal && l.deal.status === dealStatus.completed),
                )
                .sort((a: Deals, b: Deals) => {
                    return (
                        pastSorting.indexOf(a && a.deal && a.deal.status) -
                        pastSorting.indexOf(b && b.deal && b.deal.status)
                    );
                });
        const deals = ongoingDeals.concat(pastDeals);
        yield put(
            DealActions.setDeals({
                deals: deals || [],
                ongoingDeals: ongoingDeals || [],
                pastDeals: pastDeals || [],
            }),
        );
    } catch (err) {
        yield put(MessageActions.showMessage({ error: true, text: String(err) }));
        yield put(
            DealActions.setDeals({
                deals: [],
                ongoingDeals: [],
                pastDeals: [],
            }),
        );
    }
};

const fetchDealDetailReq = function* fetchDealDetailReq(action: CommonAction) {
    try {
        const { uuid } = action.payload;
        const { data } = yield call(Apis.dealDetails, uuid);
        if (data?.deal?.info?.summary?.dealType === dealTypes.fund) {
            const res: { data: null | undefined | { uuid: string; dealUUID: string; userUUID: string }[] } = yield call(
                Apis.dealDisclosure,
                uuid,
            );
            yield put(DealActions.setDisclosure(res.data && res.data.length > 0 ? false : true));
            yield put(DealActions.fetchTrackRecords(uuid));
        }
        yield put(DealActions.getTermSheetReq(uuid));
        yield put(DealActions.setDealDetail(data));
    } catch (err) {
        const { history } = action.payload;
        yield put(MessageActions.showMessage({ error: true, text: String(err) }));
        yield put(DealActions.setDealDetail(undefined));
        history(HEADERMENU_PATH.deals);
    }
};

const fetchDealDataRoomReq = function* fetchDealDataRoomReq(action: CommonAction) {
    try {
        const dealUUID = action.payload;
        const { data } = yield call(Apis.dealDataRoomReq, dealUUID);
        yield put(DealActions.setDealDataRoom(data || []));
    } catch (err) {
        yield put(MessageActions.showMessage({ error: true, text: String(err) }));
        yield put(DealActions.setDealDataRoom([]));
    }
};

const fetchDealWebinarReq = function* fetchDealWebinarReq(action: CommonAction) {
    try {
        const dealUUID = action.payload;
        const { data } = yield call(Apis.dealWebinarReq, dealUUID);
        yield put(DealActions.setDealWebinars(data || []));
    } catch (err) {
        yield put(MessageActions.showMessage({ error: true, text: String(err) }));
        yield put(DealActions.setDealWebinars([]));
    }
};

const fetchTrackRecords = function* fetchTrackRecords(action: CommonAction) {
    try {
        const dealUUID = action.payload;
        const { data } = yield call(Apis.fetchTrackRecords, dealUUID);
        yield put(DealActions.setTrackRecords(data));
    } catch (err) {
        yield put(DealActions.setTrackRecords(undefined));
    }
};

const fetchCashflowSimulatorReq = function* fetchCashflowSimulatorReq(action: CommonAction) {
    try {
        const payload = action.payload;
        const { data } = yield call(Apis.fetchCashflowSimulator, payload);
        const cashflowGraph = commonUtils.parseCashflow(data || []);
        yield put(DealActions.setCashflowSimulator(cashflowGraph));
    } catch (err) {
        yield put(MessageActions.showMessage({ error: true, text: String(err) }));

        yield put(DealActions.setCashflowSimulator([]));
    }
};

const fetchDealTermSheetDataReq = function* fetchDealTermSheetDataReq(action: CommonAction) {
    try {
        const dealUUID = action.payload;
        const { data } = yield call(Apis.dealTermSheetReq, dealUUID);

        yield put(DealActions.setTermSheetData(data || ''));
    } catch (err) {
        yield put(MessageActions.showMessage({ error: true, text: String(err) }));
        yield put(DealActions.setTermSheetData(''));
    }
};
const fetchTeaserDocReq = function* fetchTeaserDocReq(action: CommonAction) {
    try {
        const dealUUID = action.payload;
        const { data } = yield call(Apis.fetchTeaserDoc, dealUUID);
        yield put(DealActions.setTeaserDoc(data || []));
    } catch (err) {
        yield put(DealActions.setTeaserDoc([]));
    }
};

export default function* sagas() {
    yield takeLatest(DealTypes.GET_DEALS_REQ, fetchDealsReq);
    yield takeLatest(DealTypes.GET_DEAL_DETAIL_REQ, fetchDealDetailReq);
    yield takeLatest(DealTypes.GET_DEAL_DATA_ROOM_REQ, fetchDealDataRoomReq);
    yield takeLatest(DealTypes.GET_DEAL_WEBINAR_REQ, fetchDealWebinarReq);
    yield takeLatest(DealTypes.FETCH_TRACK_RECORDS, fetchTrackRecords);
    yield takeLatest(DealTypes.FETCH_CASHFLOW_SIMULATOR, fetchCashflowSimulatorReq);
    yield takeLatest(DealTypes.GET_TERM_SHEET_DATA_REQ, fetchDealTermSheetDataReq);
    yield takeLatest(DealTypes.FETCH_TEASER_DOC, fetchTeaserDocReq);
}
